export default {"src":"/_next/static/media/icon-enerflo-docflo-document-accuracy.1ff3e059.svg","height":129,"width":128};